<template>
  <div class="other-nat-home">
    <img
      :src="require('@assets/img_nat_banner.png')"
      class="other-nat-home-banner"
      alt=""
    />
    <div class="other-nat-home-function">
      <div
        :style="bgStyle"
        style="display:flex;align-items: center;width:100%;height:5rem;color:white;"
        @click="gotoNat"
      >
        <img
          :src="require('@/assets/ic_nat_price.png')"
          style="width:3rem;height:3rem;margin:1rem 1rem 1rem 2rem;"
          alt=""
        />
        <div>
          <div style="font-weight:600;font-size:1rem;letter-spacing:5px;">
            核酸开单
          </div>
          <div style="font-size:.6rem">费用：{{ price }}元/人次</div>
        </div>
      </div>

      <!-- <img
        :src="require('@assets/ic_nat_home_hsyy.png')"
        alt=""
        style="width:100%"
        @click="gotoNat"
      /> -->
      <div class="other-nat-home-function-sub">
        <img
          :src="require('@assets/ic_nat_home_wdbg.png')"
          alt=""
          style="width:calc(50% - 0.2rem);margin-right:.2rem"
          @click="gotoReport"
        />

        <img
          :src="require('@assets/ic_nat_home_kdjl.png')"
          alt=""
          style="width:calc(50% - 0.2rem);margin-left:.2rem"
          @click="gotoRecord"
        />
      </div>
    </div>
    <div class="other-nat-home-tips">
      <div class="other-nat-home-tips-title">*预约须知</div>
      <div class="other-nat-home-tips-content">
        1、该服务功能仅支持就诊卡开单，提交之前请确认信息是否正确<br />
        2、该服务功能仅支持线上核酸检测开单，采样工作请您到医院现场指定地点按照要求进行采集<br />
        3、申请提交成功后，会自动跳转进行结算<br />
        4、如需查询核酸检测报告结果，可通过该公众号“我的报告”入口进行查询<br />
        5、如需退费，请到医院现场窗口处理<br />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      openId: "",
      price: "28",
      bgStyle: {
        backgroundImage: `url(${require("@assets/ic_nat_appoint.png")}`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%"
      }
    };
  },
  created() {
    this.openId = this.$route.query.openId;
    // this.openId = "1111";
    this.getprice();
  },
  methods: {
    gotoNat() {
      this.$router.push({
        name: "nucleic-acid-user-info",
        query: {
          openId: this.openId
        }
      });
    },
    gotoRecord() {
      this.$router.push({
        name: "nucleic-acid-test-record",
        query: {
          openId: this.openId
        }
      });
    },
    gotoReport() {
      // this.$router.push({
      //     name: "nucleic-record-login",
      //     query: {
      //       openId: this.openId
      //     }
      //   });
      window.location.href =
        "https://app.fjlyrmyy.com/distV4/#/other/nat/record/login";
    },
    //获取核酸开单金额
    getprice() {
      this.$http.post(this.$api.GET_HS_ORDER_AMOUNT, {}).then(res => {
        this.price = res.orderAmount;
      });
    }
  }
};
</script>

<style lang="less">
.other-nat-home {
  &-banner {
    width: 100%;
  }

  &-function {
    padding: 1rem;
    color: white;
    border-radius: 0.67rem 0.67rem 0 0;
    &-sub {
      display: flex;
      justify-content: space-between;
      margin-top: 0.67rem;
      font-weight: 600;
      span {
        font-size: 0.7rem;
      }

      &-appointment {
        width: calc(50% - 0.2rem);
        height: auto;
        margin-right: 0.2rem;
        padding: 0 0.5rem 0 1rem;
        background-image: url("~@/assets/ic_nat_home_wdbg.png");
        background-repeat: no-repeat;
        background-size: 100% auto;
        border-radius: 0.5rem;
      }
      &-report {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: calc(50% - 0.2rem);
        margin-left: 0.2rem;
        padding: 1rem 0.5rem 1rem 1rem;
        background-image: url("~@/assets/ic_nat_home_wdbg.png");
        background-repeat: no-repeat;
        background-size: 100% auto;
        border-radius: 0.5rem;
        img {
          width: 1.5rem;
        }
      }
    }
  }
  &-tips {
    margin: 1rem;
    overflow: hidden;
    border: 1px solid #efefef;
    border-radius: 0.67rem;
    &-title {
      color: #108eee;
      font-weight: 500;
      font-size: 1.13rem;
      line-height: 3.33rem;
      text-align: center;
      background-color: #ecf9ff;
    }
    &-content {
      padding: 1rem;
      color: #666;
      font-size: 0.9rem;
    }
  }
}
</style>
